import React from 'react'
import moment from 'moment'
import { Text } from '@Common/Components'

function SearchDataRender ({ data }) {
  return (
    <>
      {data.type
        ? (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Text value='Tipo pratica:' style={{ marginRight: 5 }} />
            <Text bold value={data.type} />
          </div>)
        : null}
      {data.year
        ? (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Text value='Anno: ' style={{ marginRight: 5 }} />
            <Text bold value={data.year} />
          </div>)
        : null}
      {data.number
        ? (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Text value='Numero: ' style={{ marginRight: 5 }} />
            <Text bold value={data.number} />
          </div>)
        : null}
      {data.startDate1
        ? (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Text value='Data Partenza da: ' style={{ marginRight: 5 }} />
            <Text bold value={moment(data.startDate1, 'YYYYMMDD').format('DD/MM/YYYY')} />
          </div>)
        : null}
      {data.startDate2
        ? (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Text value='Data Partenza a: ' style={{ marginRight: 5 }} />
            <Text bold value={moment(data.startDate2, 'YYYYMMDD').format('DD/MM/YYYY')} />
          </div>)
        : null}
      {data.registrationDate1
        ? (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Text value='Data Registrazione da: ' style={{ marginRight: 5 }} />
            <Text bold value={moment(data.registrationDate1, 'YYYYMMDD').format('DD/MM/YYYY')} />
          </div>)
        : null}
      {data.registrationDate2
        ? (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Text value='Data Registrazione a: ' style={{ marginRight: 5 }} />
            <Text bold value={moment(data.registrationDate2, 'YYYYMMDD').format('DD/MM/YYYY')} />
          </div>)
        : null}
    </>
  )
}

export default SearchDataRender
